import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { smssubmitcode } from '../models/onlinesms.models/smssubmitcode';



@Injectable()
export class onlinesmsservices {
  constructor(private http: HttpClient) {

  }

  Getcode(id) {
    return this.http.get(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/AnsweringSmsRequest/' + id);
  }
  GetAnswering(mobile, code) {
    return this.http.get(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/ApproveSms/' + mobile + '/' + code);
  }
  GetcodeCorona(id) {
    return this.http.get(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/AnsweringSmsRequestCorona/' + id);
  }
  GetAnsweringCorona(nationalCode, code) {
    return this.http.get(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/ApproveSmsCorona/' + nationalCode + '/' + code);
  }
}
